module.exports = __webpack_public_path__ + "img/wallet.b225d5c9.svg";